import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function getSubscription(onSuccessEvent, onErrorEvent) {
  const response = await sendRequest()
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest() {
  const storeId = await self.servicesVars.getStoreId()
  const url = `${urls.getSubscription}${storeId}`
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  console.log(response)
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    const rawData = response.response.data
    const appData = Formatter.parseExternalSubscription(rawData)

    return {
      success: true,
      data: appData,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response?.statusCode == 404
  ) {
    const appData = Formatter.parseExternalSubscription({})

    return {
      success: true,
      data: appData,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getSubscription }
